import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Badge, Nav, NavItem, NavLink as RsNavLink } from 'reactstrap';
import isExternal from 'is-url-external';
import classNames from 'classnames';
import SidebarFooter from './../SidebarFooter';
import SidebarForm from './../SidebarForm';
import SidebarHeader from './../SidebarHeader';
import { connect } from 'react-redux'
import studentUser from '../../helpers/users/testing/studentUser'
import getSidebar from '../../helpers/nav/getSidebar';
import hyphenate from 'mout/string/hyphenate'


class Sidebar extends Component {



  handleClick(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle('open');
  }

  activeRoute(routeName, props) {
    // return this.props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
    return props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
  }

  // todo Sidebar nav secondLevel
  // secondLevelActive(routeName) {
  //   return this.props.location.pathname.indexOf(routeName) > -1 ? "nav nav-second-level collapse in" : "nav nav-second-level collapse";
  // }



  render() {
    const user = this.props.testUser || studentUser // districtAdmin  //superAdmin
    const props = this.props;
    const activeRoute = this.activeRoute;
    const handleClick = this.handleClick;

    // badge addon to NavItem
    const badge = (badge) => {
      if (badge) {
        const classes = classNames(badge.class);
        return (<Badge className={classes} color={badge.variant}>{badge.text}</Badge>)
      }
    };

    // simple wrapper for nav-title item
    const wrapper = item => { return (item.wrapper && item.wrapper.element ? (React.createElement(item.wrapper.element, item.wrapper.attributes, item.name)) : item.name) };

    // nav list section title
    const title = (title, key) => {
      const classes = classNames(`nav-title`, title.class);
      return (<li key={key} className={classes}>{wrapper(title)} </li>);
    };

    // nav list divider
    const divider = (divider, key) => (<li key={key} className="divider"></li>);

    // nav item with nav link
    const navItem = (item, hasParent, key) => {
      const classes = classNames(item.class);
      const variant = classNames("nav-link", item.variant ? `nav-link-${item.variant}` : "");
      return (
        <NavItem key={key} className={`${classes} ${hyphenate(item.name)}`}>
          {isExternal(item.url) ?
            <RsNavLink href={item.url} className={variant} activeClassName="active">
              <i className={`${item.icon}`}></i>{item.name}{badge(item.badge)}
            </RsNavLink>
            :
            <span>
              {hasParent && <div className='test'></div>}
              <NavLink to={item.url} className={variant} isActive={(match, location) => item.url.startsWith(location.pathname) || location.pathname.includes(item.url)} activeClassName="active">
                {item.name}{badge(item.badge)}
              </NavLink>
            </span>
          }
        </NavItem>
      )
    };

    // nav dropdown
    const navDropdown = (item, key) => {
      return (
        <li key={key} className={activeRoute(item.url, props)}>
          <a className="nav-link nav-dropdown-toggle" href="#" onClick={handleClick.bind(this)}><i className={`${item.icon} ${item.name}`}></i>{item.name}</a>
          <ul className="nav-dropdown-items">
            {navList(item.children, true)}
          </ul>
        </li>)
    };

    const navLogout = (item, key) => {
      return (
        <li key={key} className={activeRoute(item.url, props)}>
          <a className="nav-link nav-dropdown-toggle" href="#" onClick={handleClick.bind(this)}><i className={`${item.icon} ${item.name}`}></i>{item.name}</a>
          <ul className="nav-dropdown-items">
            {navList(item.children, true)}
          </ul>
        </li>)
    };

    // nav link
    const navLink = (item, hasParent, idx) =>
      item.title ? title(item, idx) :
        item.divider ? divider(item, idx) :
          item.children ? navDropdown(item, idx)
            : navItem(item, hasParent, idx);

    // nav list
    const navList = (items, hasParent) => {
      return items.map((item, index) => navLink(item, hasParent, index));
    };

    // sidebar-nav root
    return (
      <div className="sidebar">
        <SidebarHeader />
        <a className="logo" href="#"><img src="https://firebasestorage.googleapis.com/v0/b/bellwork-cg1.appspot.com/o/images%2Fmp-online-header-image.svg?alt=media&token=1145b2cf-f84d-43f7-9f03-57ac15d6ba48" alt="MasteryPrep Logo" /></a>
        <SidebarForm />
        <nav className="sidebar-nav">
          <Nav>
            {navList(getSidebar(user, this.props.location.search, this.props.location.pathname, this.props.match.params, this.props.userAssessment, this.props.userLicenses).items)}
          </Nav>
        </nav>
        <SidebarFooter logout={props.testUser} />
      </div>
    )
  }
}

export default connect(
  (state) => ({
    testUser: state.users.testUser,
    userAssessment: state.assessment.userAssessment,
  })
)(Sidebar)





// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js